import React from "react";
import ResetPassword from "../../component/login/resetPassword";
export function ResetPasswordd() {
  return (
    <div style={{height:'85vh', color:'var(--text-clr)'}}>
      < ResetPassword/>
    </div>
  );
}
